import React from 'react'
import { Box, Card, CardContent, Grid, Typography } from '@material-ui/core'

import { Case, Generic, Place, Product } from 'src/api/models'

import { CaseCard } from './Case'
import { PlaceCard } from './Place'
import { ProductCard } from './Product'

const cardMap: { [type: string]: React.FC<any> } = {
  [Case.type]: CaseCard,
  [Product.type]: ProductCard,
  [Place.type]: PlaceCard,
}

interface GenericCardProps {
  item: Generic
  itemProps?: object
}

export const GenericCard = (props: GenericCardProps) => {
  const { item, itemProps } = props
  const Icon = item?.object?.icon
  const ModelCard = cardMap[item.object.type]
  if (ModelCard) {
    return <ModelCard item={item.object} {...itemProps} />
  }
  return (
    <Card>
      <CardContent>
        <Typography>
          <Icon /> {item.object.typeDisplay}
        </Typography>
        <Grid container>
          <Grid item container spacing={6} xs={12}>
            <Grid item>
              <Box fontWeight="bold">SquID:</Box>
            </Grid>
            <Grid item>{item.id}</Grid>
          </Grid>
          <Grid item container spacing={6} xs={12}>
            <Grid item>
              <Box fontWeight="bold">Name:</Box>
            </Grid>
            <Grid item>{item.object.name}</Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
